import React from 'react';
import { View } from 'react-native';
import { Icon } from '@ant-design/react-native';
import { colorPalette } from '@shared/config/colorsConfig';
import { CHAT_ROW } from '../../constants';
import type { TChannelKind, TChatChannelAvatarProps } from '../../types';

const AVATAR_ICON: Record<TChannelKind, 'usergroup-add' | 'setting' | 'solution'> = {
    clinical: 'usergroup-add',
    technicalSupport: 'setting',
    other: 'solution',
};

export const ChatChannelAvatar = ({ kind }: TChatChannelAvatarProps) => (
    <View
        style={{ width: CHAT_ROW.avatarSize, height: CHAT_ROW.avatarSize, borderRadius: CHAT_ROW.avatarSize / 2 }}
        className="items-center justify-center shrink-0 bg-secondary-100"
    >
        <Icon name={AVATAR_ICON[kind]} size={CHAT_ROW.avatarIconSize} color={colorPalette.secondary[600]} />
    </View>
);
